import { render, staticRenderFns } from "./KT-PortfolioForecast.vue?vue&type=template&id=3b13b072&scoped=true&"
import script from "./KT-PortfolioForecast.vue?vue&type=script&lang=js&"
export * from "./KT-PortfolioForecast.vue?vue&type=script&lang=js&"
import style0 from "./KT-PortfolioForecast.vue?vue&type=style&index=0&id=3b13b072&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13b072",
  null
  
)

export default component.exports